export enum CarouselDirection {
  Rigth,
  Left
}

export enum StyleDots {
  Home,
  HotelsResults,
  Upsell
}

export enum PositionDots {
  Center,
  Right
}
